import { AbstractControl, ValidatorFn } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  const UPPERCASE = new RegExp('.*\\p{Ll}.*', 'gu');
  const LOWERCASE = new RegExp('.*\\p{Lu}.*', 'gu');
  const DIGITS = new RegExp('.*[0123456789].*', 'g');
  const SPECIAL_CHARACTERS = new RegExp('.*[!@#$%\\\\^&*()_=+\\[\\]{}|;:,.<>?-].*', 'g');

  function matchCount(password: string, regex: RegExp) {
    return password.match(regex) ? 1 : 0;
  }

  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value: string | undefined | null = control.value;

    if (!value) {
      return null;
    }

    const matchCounter =
      matchCount(value, UPPERCASE) +
      matchCount(value, LOWERCASE) +
      matchCount(value, DIGITS) +
      matchCount(value, SPECIAL_CHARACTERS);

    if (matchCounter < 3) {
      return { invalidPassword: true };
    }
    return null;
  };
}
